import * as React from 'react';
import {PaletteMode} from '@mui/material';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import ToggleColorMode from './ToggleColorMode';
import MenuAppBar from "../MenuAppBar";
import SiteScan from "./SiteScan";
import {APP_NAME} from "../App";


interface AppAppBarProps {
    mode: PaletteMode;
    toggleColorMode: () => void;
    storyConf: any[];
    usernameConf: any[];
    notif: (m: string) => void;
}

function AppAppBar({mode, toggleColorMode, storyConf, usernameConf, notif}: AppAppBarProps) {
    const [open, setOpen] = React.useState(false);

    const toggleDrawer = (newOpen: boolean) => () => {
        setOpen(newOpen);
    };

    return (
        <div>
            <AppBar
                position="fixed"
                enableColorOnDark
                sx={{
                    boxShadow: 0,
                    backgroundColor: 'transparent',
                    backgroundImage: 'none',
                    mt: 'calc(var(--template-frame-height, 0px) + 28px)',
                }}
            >
                <Container maxWidth="lg">
                    <Toolbar
                        variant="regular"
                        sx={(theme) => ({
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexShrink: 0,
                            borderRadius: '10px',
                            backgroundColor:
                                theme.palette.mode === 'light'
                                    ? 'rgba(255, 255, 255, 0.4)'
                                    : 'rgba(0, 0, 0, 0.4)',
                            backdropFilter: 'blur(24px)',
                            maxHeight: 40,
                            border: '1px solid',
                            borderColor: 'divider',
                            boxShadow:
                                theme.palette.mode === 'light'
                                    ? `0 0 1px rgba(85, 166, 246, 0.1), 1px 1.5px 2px -1px rgba(85, 166, 246, 0.15), 4px 4px 12px -2.5px rgba(85, 166, 246, 0.15)`
                                    : '0 0 1px rgba(2, 31, 59, 0.7), 1px 1.5px 2px -1px rgba(2, 31, 59, 0.65), 4px 4px 12px -2.5px rgba(2, 31, 59, 0.65)',
                        })}
                    >
                        <Box
                            sx={{
                                flexGrow: 1,
                                display: 'flex',
                                alignItems: 'center',
                                ml: '-18px',
                                px: 0,
                            }}
                        >

                            <Box>
                                <Typography variant="h6"
                                            sx={{fontSize: {sm: 30}, userSelect: "none"}} color="text.primary" px={1}>
                                    {APP_NAME}
                                </Typography>
                            </Box>
                        </Box>

                        <SiteScan notif={notif}/>

                        <Typography px={1}>
                            <ToggleColorMode mode={mode} toggleColorMode={toggleColorMode}/>
                        </Typography>

                        <Box
                            sx={{
                                gap: 0.5,
                                alignItems: 'center',
                            }}
                        >
                            <Button
                                variant="text"
                                color="primary"
                                aria-label="menu"
                                size="small"
                                onClick={toggleDrawer(true)}
                                sx={{minWidth: '10px', p: '3px'}}>
                                <MenuIcon/>
                            </Button>
                        </Box>
                        <Box sx={{display: {sm: '', md: 'none'}}}>
                            <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                                <Box
                                    sx={{
                                        minWidth: '15dvw',
                                        p: 2,
                                        backgroundColor: 'background.paper',
                                        flexGrow: 1,
                                    }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            flexGrow: 1,
                                            gap: "30px",
                                        }}>

                                        <MenuAppBar usernameConf={usernameConf} storyConf={storyConf}/>

                                    </Box>
                                </Box>
                            </Drawer>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </div>
    );
}

export default AppAppBar;
